module.exports = new __parcel__URL__("floor.5817588f.jpg").toString();